const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" d=\"M12 18V8v10Zm0 5c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11Zm5-11l-5-5l-5 5\"/>"
};
exports.__esModule = true;
exports.default = data;
